<template>
  <layout :menus="[]" :hide-header-comp="true" :main-cover-all="true">
    <router-view :key="$route.fullPath" />
  </layout>
</template>

<script>
import { Layout } from "@ajx-common/trth-web-common";

export default {
  components: {
    Layout,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
